export const dc_clusterTechniques = [
    {
      value: 1,
      label: 'K-means clustering'
    },
    {
      value: 2,
      label: 'Hierarchical clustering'
    }
  ];
  
  export const dc_clusteringMethods = [
    {
      value: 1,
      label: 'Nearest neighbor'
    },
    {
      value: 2,
      label: 'Furthest neighbor'
    },
    {
      value: 3,
      label: 'Centroid clustering'
    },
    {
      value: 4,
      label: 'Median clustering'
    },
    {
      value: 5,
      label: "Ward's method"
    },
  ];
  
  export const dc_clusteringIntervals = [
    {
      value: 1,
      label: 'Euclidean distance'
    },
    {
      value: 2,
      label: 'Squared Euclidean distance'
    },
    {
      value: 3,
      label: 'Block'
    },
    {
      value: 4,
      label: 'Chebychev'
    },
    {
      value: 5,
      label: 'Cosine'
    },
    {
      value: 6,
      label: 'Minkowski'
    },
    {
      value: 7,
      label: 'Pearson correlation'
    }
  ];
  
  export const dc_transformations = [
    {
      value: 1,
      label: 'None'
    },
    {
      value: 2,
      label: 'Normalize'
    },
    {
      value: 3,
      label: 'Absolute values'
    },
    {
      value: 4,
      label: 'Rescale 0-1'
    }
  ];
  
  export const dc_dataScaling = [
    {
      value: 1,
      label: 'None'
    },
    {
      value: 2,
      label: 'Normalize'
    },
    {
      value: 3,
      label: 'Absolute values'
    },
    {
      value: 4,
      label: 'Rescale 0-1'
    }
  ];
  
  export const dc_colorCodes = [
    '#E6194B',
    '#3CB44B',
    '#FFE119',
    '#4363D8',
    '#F58231',
    '#911EB4',
    '#42D4F4',
    '#F032E6',
    '#BFEF45',
    '#FABED4',
    '#469990',
    '#DCBEFF',
    '#9A6324',
    '#000000',
    '#800000',
    '#AAFFC3',
    '#ABDBE3',
    '#FFD8B1',
    '#000075',
    '#A9A9A9',
    '#00FF17',
    '#CFB407'
  ];
  
  export const dc_conditionsDropdownData = [
    {
      id: '<',
      label: 'is less than'
    },
    {
      id: '<=',
      label: 'is less than or equal to'
    },
    {
      id: '>',
      label: 'is greater than'
    },
    {
      id: '>=',
      label: 'is greater than or equal to'
    },
    {
      id: '==',
      label: 'is'
    },
    {
      id: '!=',
      label: 'is not'
    },
    {
      id: 'is blank',
      label: 'is blank'
    },
    {
      id: 'is not blank',
      label: 'is not blank'
    }
  ];
  
  export const dc_segmentationColumnVariables = [
    {
      id: 'Length',
      label: 'Relationship duration'
    },
    {
      id: 'Recency',
      label: 'Day since last purchase'
    },
    {
      id: 'Frequency',
      label: 'Purchase per half year'
    },
    {
      id: 'Monetary',
      label: 'Monetary per half year'
    },
    {
      id: 'Variety',
      label: 'Breadth of item purchase'
    }
  ];
  
  export const DC_SEGMENTATION_OUTLIER_ID = 10000;
  
  export const DC_SEGMENTATION_OUTLIER_COL_NAM = 'Outliers';
  